import React from 'react';
import {
  Dialog as MuiDialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
} from '@mui/material';
import { acme, acmeDialogPaperSx } from '../../theme/acmeTheme';
import { mergeSx } from './utils/mergeSx';

export function Dialog({ children, PaperProps, sx, ...props }) {
  return (
    <MuiDialog
      PaperProps={{
        ...PaperProps,
        sx: mergeSx(acmeDialogPaperSx, PaperProps?.sx),
      }}
      {...props}
    >
      {children}
    </MuiDialog>
  );
}

export function DialogHeader({ title, description, sx, children }) {
  return (
    <Box sx={mergeSx({ px: 3, pt: 2.5, pb: children ? 1 : 0 }, sx)}>
      {title && (
        <Typography component="h2" sx={{ fontWeight: 600, fontSize: '1.125rem', color: acme.colors.foreground }}>
          {title}
        </Typography>
      )}
      {description && (
        <Typography sx={{ fontSize: '0.875rem', color: acme.colors.mutedForegroundSolid, mt: 0.5 }}>
          {description}
        </Typography>
      )}
      {children}
    </Box>
  );
}

export function DialogTitleText({ children, sx, ...props }) {
  return (
    <DialogTitle
      sx={mergeSx({ fontWeight: 600, fontSize: '1.125rem', color: acme.colors.foreground, pb: 1 }, sx)}
      {...props}
    >
      {children}
    </DialogTitle>
  );
}

export function DialogBody({ sx, children, ...props }) {
  return (
    <DialogContent sx={mergeSx({ px: 3, pt: 1 }, sx)} {...props}>
      {children}
    </DialogContent>
  );
}

export function DialogFooter({ sx, children, ...props }) {
  return (
    <DialogActions sx={mergeSx({ px: 3, pb: 2.5, pt: 1, gap: 1 }, sx)} {...props}>
      {children}
    </DialogActions>
  );
}

Dialog.Header = DialogHeader;
Dialog.Title = DialogTitleText;
Dialog.Body = DialogBody;
Dialog.Footer = DialogFooter;

export default Dialog;
